'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var alphaNumericRegex = /[a-z0-9]/i;

var hasAnyAlphanumericCharacter = exports.hasAnyAlphanumericCharacter = function hasAnyAlphanumericCharacter(value) {
  return alphaNumericRegex.test(value);
};

var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

var isValidEmail = exports.isValidEmail = function isValidEmail(email) {
  if (!email) return false;

  return emailRegex.test(email);
};

var zipCodeRegex = {
  at: RegExp(/^\d{4}$/),
  ch: RegExp(/^\d{4}$/),
  de: RegExp(/^\d{5}$/),
  fr: RegExp(/^\d{5}$/),
  it: RegExp(/^\d{5}$/),
  pl: RegExp(/^\d{2}-\d{3}$/)
};

var isValidZipCode = exports.isValidZipCode = function isValidZipCode(zipCode, countryCode) {
  if (!zipCode || !countryCode) return false;

  var regex = zipCodeRegex[countryCode.toLowerCase()];

  if (!regex) return true;

  return regex.test(zipCode);
};

var isValidOrderName = exports.isValidOrderName = function isValidOrderName(orderName) {
  if (!orderName) return false;
  if (!window.theme.orderRegex) return true;

  return window.theme.orderRegex.test(orderName);
};

var isValidAddress = exports.isValidAddress = function isValidAddress(address) {
  return address !== '' && /\d/.test(address);
};

var dobRegex = /^\d{4}[-/\s]?((((0[13578])|(1[02]))[-/\s]?(([0-2][0-9])|(3[01])))|(((0[469])|(11))[-/\s]?(([0-2][0-9])|(30)))|(02[-/\s]?[0-2][0-9]))$/;

var isValidDOB = exports.isValidDOB = function isValidDOB(dob) {
  return dobRegex.test(dob);
};